export const API_URL = process.env.API_URL as string;
export const MANUAL_URL = process.env.MANUAL_URL as string;
